import { BasicCartesianChartConfig } from '@app/data/interface/widget-config';
import {
  BasicCartesianChartEchartConfigTemplate,
  BasicCartesianChartAxisTemplate,
} from '@app/data/widget-config-templates/basic-cartesian-chart';
export const WhakaaweWaihoraBay: BasicCartesianChartConfig = {
  echartsConfig: {
    ...BasicCartesianChartEchartConfigTemplate,
    color: ['#8c7ebb', '#66c39b', '#007093'],
    grid: {
      top: '25%',
      left: '18%',
      right: '7%',
      bottom: '6%',
      containLabel: true,
    },
    yAxis: [
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'TDP\ng/m³',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#8c7ebb',
          },
        },
        axisLabel: {
          color: '#8c7ebb',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'Rainfall\nmm',
        offset: 50,
        axisLine: {
          show: true,
          lineStyle: {
            color: '#66c39b',
          },
        },
        axisLabel: {
          color: '#66c39b',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'TAN\ng/m³',
        position: 'right',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#007093',
          },
        },
        axisLabel: {
          color: '#007093',
        },
      },
    ],
    series: [
      {
        type: 'line',
        yAxisIndex: 0,
        name: 'Total Dissolved Phosphorus',
        symbolSize: 13,
      },
      {
        type: 'line',
        yAxisIndex: 1,
        name: 'Precipitation',
        symbolSize: 13,
      },
      {
        type: 'line',
        yAxisIndex: 2,
        name: 'Total Ammoniacal Nitrogen',
        symbolSize: 13,
      },
    ],
  },
  dataConfig: {
    title: 'WHAKAAWE WHENUA - Land Use Impact: Waihora Bay',
    widgetId: 1,
    domain: 'wai',
    dataSources: [
      {
        environmentalDataSourceIdentifier: 'wrc_72/1089',
        analyteIdentifier: 'total-phosphorus',
        valueField: 'avg',
        label: 'Total Phosphorus',
      },
      {
        environmentalDataSourceIdentifier: 'wrc_275/2',
        analyteIdentifier: 'precipitation',
        valueField: 'sum',
        label: 'Precipitation',
      },
      {
        environmentalDataSourceIdentifier: 'wrc_72/1089',
        analyteIdentifier: 'total-ammoniacal-nitrogen',
        valueField: 'avg',
        label: 'Total Nitogen',
      },
    ],
  },
};

export const WaiWhareroaFishTrap: BasicCartesianChartConfig = {
  echartsConfig: {
    ...BasicCartesianChartEchartConfigTemplate,
    color: ['#66c39b'],
    grid: {
      top: '25%',
      left: '7%',
      right: '7%',
      bottom: '6%',
      containLabel: true,
    },
    yAxis: [
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'Relative\nWater\nLevel\nm',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#66c39b',
          },
        },
        axisLabel: {
          color: '#66c39b',
        },
      },
    ],
    series: [
      {
        type: 'line',
        yAxisIndex: 0,
        name: 'Relative Water Level',
      },
    ],
  },
  dataConfig: {
    title: 'WAI - Field Water Sampling: Whareroa (Fish Trap)',
    widgetId: 2,
    domain: 'wai',
    dataSources: [
      {
        environmentalDataSourceIdentifier: 'wrc_1318/5',
        analyteIdentifier: 'relative-water-level',
        valueField: 'avg',
        label: 'Relative Water Level',
      },
    ],
  },
};

export const AnalyteWaiKuratau: BasicCartesianChartConfig = {
  echartsConfig: {
    ...BasicCartesianChartEchartConfigTemplate,
    color: ['#f26b4b', '#8c7ebb', '#ee4891'],
    grid: {
      top: '25%',
      left: '7%',
      right: '15%',
      bottom: '6%',
      containLabel: true,
    },
    yAxis: [
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'ph inField',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#f26b4b',
          },
        },
        axisLabel: {
          color: '#f26b4b',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'DRP\ng/m³',
        position: 'right',
        offset: 40,
        axisLine: {
          show: true,
          lineStyle: {
            color: '#8c7ebb',
          },
        },
        axisLabel: {
          color: '#8c7ebb',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'TAN\ng/m³',
        position: 'right',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#ee4891',
          },
        },
        axisLabel: {
          color: '#ee4891',
        },
      },
    ],
    series: [
      {
        type: 'line',
        yAxisIndex: 0,
        name: 'ph in Field',
      },
      {
        type: 'line',
        yAxisIndex: 1,
        name: 'Dissolved Reactive Phosphorus',
      },
      {
        type: 'line',
        yAxisIndex: 2,
        name: 'Total Ammoniacal Nitrogen',
        symbolSize: 13,
        tooltip: {
          valueFormatter: (value) => (value ? value + ' g/m³' : '-'),
        },
      },
    ],
  },
  dataConfig: {
    title: 'Analyte WAI - Field Water Sampling: Kuratau River/Te Rae Street T10',
    widgetId: 3,
    domain: 'wai',
    dataSources: [
      {
        environmentalDataSourceIdentifier: 'wrc_72/1081',
        analyteIdentifier: 'ph-in-field',
        valueField: 'avg',
        label: 'PH in Field',
      },
      {
        environmentalDataSourceIdentifier: 'wrc_72/1081',
        analyteIdentifier: 'dissolved-reactive-phosphorous',
        valueField: 'avg',
        label: 'Dissolved Reactive Phosphorus',
      },
      {
        environmentalDataSourceIdentifier: 'wrc_72/1081',
        analyteIdentifier: 'total-ammoniacal-nitrogen',
        valueField: 'avg',
        label: 'Total Ammoniacal Nitrogen',
      },
    ],
  },
};

export const AnalyteWaiLakeKuratau: BasicCartesianChartConfig = {
  echartsConfig: {
    ...BasicCartesianChartEchartConfigTemplate,
    color: ['#f26b4b', '#8c7ebb', '#ee4891', '#26312b'],
    grid: {
      top: '25%',
      left: '15%',
      right: '15%',
      bottom: '6%',
      containLabel: true,
    },
    yAxis: [
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'ph in\nField',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#f26b4b',
          },
        },
        axisLabel: {
          color: '#f26b4b',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'DRP\ng/m³',
        position: 'right',
        offset: 40,
        axisLine: {
          show: true,
          lineStyle: {
            color: '#8c7ebb',
          },
        },
        axisLabel: {
          color: '#8c7ebb',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'TAN\ng/m³',
        position: 'right',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#ee4891',
          },
        },
        axisLabel: {
          color: '#ee4891',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'Turbidity\nNTU',
        position: 'left',
        offset: 45,
        axisLine: {
          show: true,
          lineStyle: {
            color: '#26312b',
          },
        },
        axisLabel: {
          color: '#26312b',
        },
      },
    ],
    series: [
      {
        type: 'line',
        yAxisIndex: 0,
        name: 'ph in Field',
      },
      {
        type: 'line',
        yAxisIndex: 1,
        name: 'Dissolved Reactive Phosphorus',
      },
      {
        type: 'line',
        yAxisIndex: 2,
        name: 'Total Ammoniacal Nitrogen',
        symbolSize: 13,
        tooltip: {
          valueFormatter: (value) => (value ? value + ' g/m³' : '-'),
        },
      },
      {
        type: 'line',
        yAxisIndex: 3,
        name: 'Turbidity',
      },
    ],
  },
  dataConfig: {
    title: 'Analyte WAI - Field Water Sampling: Lake Kuratau',
    widgetId: 4,
    domain: 'wai',
    dataSources: [
      {
        environmentalDataSourceIdentifier: 'wrc_282/5',
        analyteIdentifier: 'ph-in-field',
        valueField: 'avg',
        label: 'PH in Field',
      },
      {
        environmentalDataSourceIdentifier: 'wrc_282/5',
        analyteIdentifier: 'dissolved-reactive-phosphorous',
        valueField: 'avg',
        label: 'Dissolved Reactive Phosphorus',
      },
      {
        environmentalDataSourceIdentifier: 'wrc_282/5',
        analyteIdentifier: 'total-ammoniacal-nitrogen',
        valueField: 'avg',
        label: 'Total Ammoniacal Nitrogen',
      },
      {
        environmentalDataSourceIdentifier: 'wrc_282/5',
        analyteIdentifier: 'turbidity',
        valueField: 'avg',
        label: 'Turbidity',
      },
    ],
  },
};

export const AnalyteWaiWaihaha: BasicCartesianChartConfig = {
  echartsConfig: {
    ...BasicCartesianChartEchartConfigTemplate,
    color: ['#f26b4b', '#8c7ebb', '#ee4891', '#26312b'],
    grid: {
      top: '25%',
      left: '15%',
      right: '15%',
      bottom: '6%',
      containLabel: true,
    },
    yAxis: [
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'ph in\nField',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#f26b4b',
          },
        },
        axisLabel: {
          color: '#f26b4b',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'DRP\ng/m³',
        position: 'right',
        offset: 40,
        axisLine: {
          show: true,
          lineStyle: {
            color: '#8c7ebb',
          },
        },
        axisLabel: {
          color: '#8c7ebb',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'TAN\ng/m³',
        position: 'right',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#ee4891',
          },
        },
        axisLabel: {
          color: '#ee4891',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'Turbidity\nNTU',
        position: 'left',
        offset: 45,
        axisLine: {
          show: true,
          lineStyle: {
            color: '#26312b',
          },
        },
        axisLabel: {
          color: '#26312b',
        },
      },
    ],
    series: [
      {
        type: 'line',
        yAxisIndex: 0,
        name: 'ph in Field',
      },
      {
        type: 'line',
        yAxisIndex: 1,
        name: 'Dissolved Reactive Phosphorus',
      },
      {
        type: 'line',
        yAxisIndex: 2,
        name: 'Total Ammoniacal Nitrogen',
        symbolSize: 13,
        tooltip: {
          valueFormatter: (value) => (value ? value + ' g/m³' : '-'),
        },
      },
      {
        type: 'line',
        yAxisIndex: 3,
        name: 'Turbidity',
      },
    ],
  },
  dataConfig: {
    title: 'Analyte WAI - Field Water Sampling: Waihāhā (Whanganui Stm/Lakeside Lake Taupo T8)',
    widgetId: 5,
    domain: 'wai',
    dataSources: [
      {
        environmentalDataSourceIdentifier: 'wrc_1301/1',
        analyteIdentifier: 'ph-in-field',
        valueField: 'avg',
        label: 'PH in Field',
      },
      {
        environmentalDataSourceIdentifier: 'wrc_1301/1',
        analyteIdentifier: 'dissolved-reactive-phosphorous',
        valueField: 'avg',
        label: 'Dissolved Reactive Phosphorus',
      },
      {
        environmentalDataSourceIdentifier: 'wrc_1301/1',
        analyteIdentifier: 'total-ammoniacal-nitrogen',
        valueField: 'avg',
        label: 'Total Ammoniacal Nitrogen',
      },
      {
        environmentalDataSourceIdentifier: 'wrc_1301/1',
        analyteIdentifier: 'turbidity',
        valueField: 'avg',
        label: 'Turbidity',
      },
    ],
  },
};

export const AnalyteWaiWhareroa: BasicCartesianChartConfig = {
  echartsConfig: {
    ...BasicCartesianChartEchartConfigTemplate,
    color: ['#f26b4b', '#8c7ebb', '#ee4891', '#26312b'],
    grid: {
      top: '25%',
      left: '15%',
      right: '15%',
      bottom: '6%',
      containLabel: true,
    },
    yAxis: [
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'ph in\nField',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#f26b4b',
          },
        },
        axisLabel: {
          color: '#f26b4b',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'DRP\ng/m³',
        position: 'right',
        offset: 40,
        axisLine: {
          show: true,
          lineStyle: {
            color: '#8c7ebb',
          },
        },
        axisLabel: {
          color: '#8c7ebb',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'TAN\ng/m³',
        position: 'right',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#ee4891',
          },
        },
        axisLabel: {
          color: '#ee4891',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'Turbidity\nNTU',
        position: 'left',
        offset: 45,
        axisLine: {
          show: true,
          lineStyle: {
            color: '#26312b',
          },
        },
        axisLabel: {
          color: '#26312b',
        },
      },
    ],
    series: [
      {
        type: 'line',
        yAxisIndex: 0,
        name: 'ph in Field',
      },
      {
        type: 'line',
        yAxisIndex: 1,
        name: 'Dissolved Reactive Phosphorus',
      },
      {
        type: 'line',
        yAxisIndex: 2,
        name: 'Total Ammoniacal Nitrogen',
        symbolSize: 13,
        tooltip: {
          valueFormatter: (value) => (value ? value + ' g/m³' : '-'),
        },
      },
      {
        type: 'line',
        yAxisIndex: 3,
        name: 'Turbidity',
      },
    ],
  },
  dataConfig: {
    title: 'Analyte WAI - Field Water Sampling: Whareroa Stm/Lakeside Lake Taupo T9',
    widgetId: 6,
    domain: 'wai',
    dataSources: [
      {
        environmentalDataSourceIdentifier: 'wrc_1301/1',
        analyteIdentifier: 'ph-in-field',
        valueField: 'avg',
        label: 'PH in Field',
      },
      {
        environmentalDataSourceIdentifier: 'wrc_1301/1',
        analyteIdentifier: 'dissolved-reactive-phosphorous',
        valueField: 'avg',
        label: 'Dissolved Reactive Phosphorus',
      },
      {
        environmentalDataSourceIdentifier: 'wrc_1301/1',
        analyteIdentifier: 'total-ammoniacal-nitrogen',
        valueField: 'avg',
        label: 'Total Ammoniacal Nitrogen',
      },
      {
        environmentalDataSourceIdentifier: 'wrc_1301/1',
        analyteIdentifier: 'turbidity',
        valueField: 'avg',
        label: 'Turbidity',
      },
    ],
  },
};
